import React from 'react'
import Pt from 'prop-types'
import Mpt from 'react-moment-proptypes'
import { Col, FormControl, Row } from 'react-bootstrap'
import moment from 'moment'
import range from 'lodash/range'

import './DateOfBirthField.css'

export default class DateOfBirthField extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      day: '',
      month: '',
      year: '',
    }

    if (props.value) {
      this.state.day = props.value.date()
      this.state.month = props.value.month()
      this.state.year = props.value.year()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({
        day: nextProps.value.date(),
        month: nextProps.value.month(),
        year: nextProps.value.year(),
      })
    } else {
      this.setState({
        day: '',
        month: '',
        year: '',
      })
    }
  }

  setItem = (key, value) => {
    this.setState({ [key]: value }, () => {
      if (this.state.day && this.state.month && this.state.year) {
        const date = moment(this.state)

        if (date.isValid()) {
          this.props.setDateOfBirth(date)
        }
      }
    })
  }

  render() {
    const numDays = this.state.month ? moment(this.state.month, 'M').daysInMonth() : 31
    const yearEnd = this.props.yearEnd || moment().subtract(this.props.minAge, 'years')
    const yearStart = moment(yearEnd).subtract(this.props.ageRange, 'years')

    return (
      <Row className="date-of-birth">
        <Col xs={6} sm={4}>
          <FormControl
            componentClass="select"
            id="dob-day"
            onChange={e => this.setItem('day', e.target.value)}
            value={this.state.day}
          >
            <option value={''}>Select a Day</option>
            {range(1, numDays + 1).map(day => (
              <option key={day} value={day}>{day}</option>
            ))}
          </FormControl>
        </Col>
        <Col xs={6} sm={4}>
          <FormControl
            componentClass="select"
            id="dob-month"
            onChange={e => this.setItem('month', e.target.value)}
            value={this.state.month}
          >
            <option value={''}>Select a Month</option>
            {moment.months().map((month, i) => (
              <option key={month} value={i}>{month}</option>
            ))}
          </FormControl>
        </Col>
        <Col xs={12} sm={4} className="dob-year">
          <FormControl
            componentClass="select"
            id="dob-year"
            onChange={e => this.setItem('year', e.target.value)}
            value={this.state.year}
          >
            <option value={''}>Select a Year</option>
            {range(yearEnd.format('YYYY'), yearStart.format('YYYY'), -1).map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
          </FormControl>
        </Col>
      </Row>
    )
  }
}

DateOfBirthField.defaultProps = {
  ageRange: 100,
  minAge: 18,
}

DateOfBirthField.propTypes = {
  ageRange: Pt.number.isRequired,
  minAge: Pt.number.isRequired,
  setDateOfBirth: Pt.func.isRequired,
  value: Mpt.momentObj,
  yearEnd: Mpt.momentObj,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Form/DateOfBirthField.jsx